import React, {Fragment} from "react";
import {Alert,TextLink} from "@myob/myob-widgets";
import "../../../../common/Common.css"
import * as PropTypes from "prop-types";

function SelectionMessage({availableFeeds, availableSelections, bankfeedLimit, isOverFeedLimit, reachSelectionLimit, handleManageFeed, handleUpgrade, source, consumerId}){
  const isFromOpenBanking = source?.toLowerCase() === "OpenBanking".toLowerCase();
  const isFromBNZ  = source?.toLowerCase() === "ProprietaryAPI".toLowerCase();
  const isFromSolo = consumerId === "Solo";

  const messages = {
    default: {
      type: "info",
      content: (
        <Fragment>
          {isFromOpenBanking ? <>
          <strong>Connect up to {bankfeedLimit} accounts</strong>
          <p>{availableSelections} connection(s) remaining. We will not save data from accounts you do not connect.</p>
          </> : <p>Your subscription includes up to {bankfeedLimit} bank account connections. You have {availableFeeds} more available.</p>}
          {isFromBNZ && (<p><b>Can't see the correct bank account?</b> You may not have access to the relevant accounts.
            <TextLink tone="info" href="https://www.myob.com/nz/support/myob-business/banking/bank-feeds/setting-up-bank-feeds/connecting-a-bnz-account-to-myob?productview=browser#cant-see-the-account-you-want-to-connect" target="_blank">
              Learn about account access
            </TextLink>
          </p>)}
        </Fragment>
      )
    },
    unlimited: {
      type: "info",
      content: (
        <Fragment>
          <p>Select which accounts you'd like to set up bank feeds for. Your subscription has an unlimited number of feeds.</p>
          {isFromBNZ && (<p><b>Can't see the correct bank account?</b> You may not have access to the relevant accounts.
            <TextLink tone="info" href="https://www.myob.com/nz/support/myob-business/banking/bank-feeds/setting-up-bank-feeds/connecting-a-bnz-account-to-myob?productview=browser#cant-see-the-account-you-want-to-connect" target="_blank">
              Learn about account access
            </TextLink>
          </p>)}
        </Fragment>
      )
    },
    overLimit: {
      type: isFromOpenBanking ? "warning" : "danger",
      content: isFromOpenBanking ? <p>You can connect up to {bankfeedLimit} accounts to MYOB. We won't save any data for the accounts you don't choose, and they won't be available in MYOB.</p> :
        <p>You have reached your {bankfeedLimit} bank feeds limit. Upgrade your subscription for unlimited bank and credit card accounts <TextLink href="" onClick={handleUpgrade}>here</TextLink>.
        Alternatively, remove an existing bank feed in <TextLink href="" onClick={handleManageFeed}>Manage bank feeds</TextLink>.</p>
    },
    reachLimit: {
      type: "warning",
      content: (
        <Fragment>
          <strong>Account limit reached</strong>
          <p>You can connect up to {bankfeedLimit} accounts. To add a different account, disconnect an account first, then connect the new one. We will not save data from accounts you do not connect.</p>
        </Fragment>
      )
    },
    reachLimitForSolo: {
      type: "warning",
        content: (
        <Fragment>
          <strong>Account limit reached</strong>
          <p>You can connect up to {bankfeedLimit} accounts. To add different accounts, remove a connection first. We
            will not save data from accounts you do not connect.</p>
        </Fragment>
      )
  }
  }

  const unlimitedPlan = bankfeedLimit === null;
  const getMessage = () => {
    if (unlimitedPlan) return messages.unlimited;
    if (isFromOpenBanking && isFromSolo && reachSelectionLimit) return messages.reachLimitForSolo;
    if (isFromOpenBanking && !isFromSolo && reachSelectionLimit) return messages.reachLimit;
    if (isOverFeedLimit) return messages.overLimit;
    return messages.default;
  }
  const message = getMessage();
  return (
    <Alert type={message.type} inline>
      {message.content}
    </Alert>
  )
}
SelectionMessage.propTypes = {
  availableFeeds: PropTypes.number,
  availableSelections: PropTypes.number,
  bankfeedLimit: PropTypes.number,
  isOverFeedLimit: PropTypes.bool,
  reachSelectionLimit: PropTypes.bool,
  handleManageFeed: PropTypes.func,
  handleUpgrade: PropTypes.func,
  source: PropTypes.string,
  consumerId: PropTypes.string
}
export default SelectionMessage
